var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeepFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 20.25L18 24.75M18 24.75L22.5 20.25M18 24.75V15.75M19.59 9.465L16.41 6.285C16.2011 6.07583 15.953 5.90988 15.6799 5.79663C15.4068 5.68338 15.1141 5.62506 14.8185 5.625H6.75C5.85489 5.625 4.99645 5.98058 4.36351 6.61351C3.73058 7.24645 3.375 8.10489 3.375 9V27C3.375 27.8951 3.73058 28.7535 4.36351 29.3865C4.99645 30.0194 5.85489 30.375 6.75 30.375H29.25C30.1451 30.375 31.0035 30.0194 31.6365 29.3865C32.2694 28.7535 32.625 27.8951 32.625 27V13.5C32.625 12.6049 32.2694 11.7465 31.6365 11.1135C31.0035 10.4806 30.1451 10.125 29.25 10.125H21.1815C20.585 10.1245 20.0116 9.88708 19.59 9.465Z",
    stroke: "#09A3A9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepFile);
export default __webpack_public_path__ + "static/media/keep-file.bb922c153eb821542456148b3f4fd47b.svg";
export { ForwardRef as ReactComponent };